module.exports = __webpack_public_path__ + "img/qjxd_banner_kr.c8d5acdf.png";